import { Pipe, PipeTransform } from '@angular/core';

import { IbRepoVerificationReasonEnum } from '../enums/ib-repo-verification-reason.enum';
import { IBlockTimeItem } from '../block-time-report.model';

@Pipe({
  name: 'ibRepoVerificationTooltip',
})
export class IbRepoVerificationTooltipPipe implements PipeTransform {
  /**
   * Builds the accountant-facing tooltip for an IB repo verification badge.
   */
  transform(record: IBlockTimeItem | null | undefined): string {
    if (!record?.ibRepoAwaitingVerification || !record.ibRepoVerificationReason) {
      return '';
    }

    if (record.ibRepoVerificationReason === IbRepoVerificationReasonEnum.NoDeparture) {
      return 'Aircraft did not depart within 12 hours. IB hours are an estimate — verify against the vendor invoice.';
    }

    if (record.ibRepoVerificationReason === IbRepoVerificationReasonEnum.AirportMismatch) {
      return `Reposition landed at ${record.actualInBoundReposition ?? 'unknown'}, not the planned ${record.inboundReposition ?? 'unknown'}. Verify against the vendor invoice.`;
    }

    if (record.ibRepoVerificationReason === IbRepoVerificationReasonEnum.IncompleteCapture) {
      return 'Landing was captured without a departure time.';
    }

    return '';
  }
}
